<template>
  <avtalat-select
    id="lamna-over-till"
    v-model:value="lamnaOverTill"
    label="Lämna över"
  >
    <option value="Nej">Nej</option>
    <optgroup
      v-for="(group, groupIndex) in options"
      :key="groupIndex"
      :label="group.label"
    >
      <option
        v-for="(item, index) in group.options"
        :key="index"
        :value="item.id"
      >
        {{ item.label }}
      </option>
    </optgroup>
  </avtalat-select>
</template>

<script setup lang="ts">
import type { LamnaOverType } from "@/composables/KundserviceAppApiClient";
import type { OptionGroup } from "@/types/form";

const lamnaOverTill = defineModel<LamnaOverType>();

defineProps<{
  options: OptionGroup[];
}>();
</script>
